__webpack_require__.p = "https://bodhi.carma.com/vue/";